export const handleSlippageInfo = () => alert(
    `Slippage refers to the difference between the expected price of a trade and the price at which the trade is executed.
If this is set too low, your transfer might fail.
For new launches, it is recommended to set this to 49 or higher.
    `
);

export const handleMaxGasInfo = () => alert(
    `Max Gas is the maximum amount of gas provided for the transaction. For normal BNB transfers, the value is 21,000. For contract this value is higher and bound by block gas limit.
    
Cost of gas fee (bnb) = 
gwei * maximum gas (recommend 700k) * 0.000000001
    `
);

export const handleGweiInfo = () => alert(
    `Cost per unit of gas specified for the transaction, in BNB and Gwei. The higher the gas price the higher chance of getting included in a block.

Cost of gas fee (bnb) = 
gwei * maximum gas (recommend 700k) * 0.000000001
    `
);

export const handleAutoSnipe = () => alert(
    `When this option is checked, once you paste the token address, it will start the snipe instantly. No need to click the Snipe Token button.`
)

export const handleNodeInfo = () => alert(
    `If you've purchased a custom node such as quicknode or chainstack, you can use your own node with the bot rather than the default public bsc node.
    
Custom nodes allow for faster transactions as they are not as flooded as the public bsc nodes. Make sure to post the https endpoint, not the wss.`
)

export const handleFrontRunInfo = () => alert(
    `If you know the Token Address ahead of time and liquidity has not been added yet, select this option to constantly check for liquidity and snipe as soon as liquidity is added.
    
This will not use gas until liquidity has been added and a transaction has been made whether successful or failed.`
)

export const handleHoneypotCheckedInfo = () => alert(
    `Check this if you want to perform a honeypot check prior to sniping.`
)

export const handleBlockDelayInfo = () => alert(
    `Enter the amount of blocks you'd like to delay the snipe by. 

1 block = 3000ms.

Useful if devs are imposing high taxes on initial blocks of tokens.
    `
)

export const handleAbiMethodInfo = () => alert(
    `Use this to snipe as soon as the dev triggers a specific method on the CA.

Cannot be combined with frontrun.`
)